import { elevationCss } from '@creditornot/cb-ingredients';
import { DragOverlay } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import React, { useMemo } from 'react';
import styled from 'styled-components';

import { PickingArea } from 'apis/picker-api/types';

import AreaRow from './AreaRow';

type Props = {
  areas: PickingArea[];
  activeAreaId: string | undefined;
  draggedAreaId: string | undefined;
  className?: string;
  onSelectArea: (areaId: string) => void;
};

const Root = styled.div`
  position: relative;
  height: 100%;
  overflow: auto;
`;

const AreaRowDragOverlay = styled(AreaRow)`
  ${elevationCss(6)};
`;

const CustomAreasList = ({ areas, activeAreaId, draggedAreaId, className, onSelectArea }: Props) => {
  const draggedArea = useMemo(() => areas.find(area => area.id === draggedAreaId), [areas, draggedAreaId]);

  return (
    <Root className={className}>
      <SortableContext items={areas} strategy={verticalListSortingStrategy}>
        {areas.map(area => (
          <AreaRow
            key={area.id}
            area={area}
            selected={activeAreaId === area.id}
            canDrag
            onClick={() => onSelectArea(area.id)}
          />
        ))}
      </SortableContext>

      <DragOverlay>{draggedArea ? <AreaRowDragOverlay area={draggedArea} canDrag /> : null}</DragOverlay>
    </Root>
  );
};

export default CustomAreasList;
